<template>
  <div>
    {{ label }}
  </div>
</template>

<script>
export default {
  data() {
    return {
      requestedMatchId: null,
    };
  },
  props: ["matchID"],
  computed: {
    match() {
      return this.$store.getters["matches/byId"](this.matchID) || {};
    },
    label() {
      if (this.match.team1Name && this.match.team2Name) {
        return `${this.match.team1Name} vs ${this.match.team2Name}`;
      }
      return this.matchID || "";
    },
  },
  watch: {
    matchID: {
      immediate: true,
      handler(id) {
        this.ensureMatchLoaded(id);
      },
    },
  },
  methods: {
    ensureMatchLoaded(matchId) {
      if (matchId == null || matchId === "") return;
      const id = String(matchId);
      if (this.$store.getters["matches/byId"](id)) return;
      if (this.requestedMatchId === id) return;
      this.requestedMatchId = id;
      this.$store.dispatch("matches/fetchById", id).catch(() => {});
    },
  },
};
</script>

<style scoped>
/* 
.card{
  position: inherit;
} */
</style>
